export default "__VITE_ASSET__BH2J7Gyf__"